import Image from 'next/image'
import Link from 'next/link'
import { trackMxEvent } from '@/utils/mixpanel'
import { cn } from '@/lib/utils'

interface Props {
  title: string
  slug: string
  disabled?: boolean
}

const CategoryPickup = ({ slug, title, disabled = false }: Props) => (
  <div>
    <Link
      href={`/cat/${slug}`}
      className={cn(
        'relative flex w-full items-center justify-center rounded-md shadow-xs transition-all duration-300 hover:scale-105',
        { 'pointer-events-none': disabled },
      )}
      onClick={() =>
        trackMxEvent('Search Category Click', {
          category_name: title,
          category_slug: slug,
        })
      }
    >
      <Image
        className="aspect-[208/152] w-full rounded-md object-cover"
        alt={`View ${title} professionals`}
        width="208"
        height="152"
        src={`/images/category/v2/${slug}.png`}
      />
    </Link>
    <div className="py-1 text-xs md:text-sm">
      <Link
        href={`/cat/${slug}`}
        className={cn({ 'pointer-events-none': disabled })}
        onClick={() =>
          trackMxEvent('Search Category Click', {
            category_name: title,
            category_slug: slug,
          })
        }
      >
        {title}
      </Link>
    </div>
  </div>
)

export default CategoryPickup
